export const CATEGORIES_ACTION_TYPES = {
    SET_CATEGORIES:'categories/SET_CATEGORIES_MAP'
}
